import React, { useEffect } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import LoginPage from './components/Auth/LoginPage';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AppLayout from './components/Layout/AppLayout';
import AdminPage from './pages/AdminPage';
import InsightDetailPage from './pages/InsightDetailPage';
import InsightsListPage from './pages/InsightsListPage';
import InterviewDetailPage from './pages/InterviewDetailPage';
import { RootState, store } from './store';
import { login } from './store/slices/authSlice';

// デモ用の自動ログイン機能（開発時のみ）
const AutoLogin: React.FC = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    // 開発時の自動ログイン（実際のプロダクションでは削除）
    if (!isAuthenticated) {
      const savedUser = localStorage.getItem('demoUser');
      if (savedUser) {
        dispatch(login(JSON.parse(savedUser)));
      }
    }
  }, [dispatch, isAuthenticated]);

  return null;
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);

  return (
    <Router>
      <AutoLogin />
      {!isAuthenticated ? (
        <Routes>
          <Route path="*" element={<LoginPage />} />
        </Routes>
      ) : (
        <AppLayout>
          <Routes>
            <Route path="/" element={<InsightsListPage />} />
            <Route path="/insights/:id" element={<InsightDetailPage />} />
            <Route path="/interviews/:id" element={<InterviewDetailPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute adminOnly>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </AppLayout>
      )}
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  );
};

export default App;
